import * as React from "react";

import { ReactComponent as DirectboxReceiveIcon } from "assets/images/svg/directbox-receive.svg";

import styles from "./SupervisorDetailsEmpty.module.scss";

export const SupervisorDetailsEmpty: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <DirectboxReceiveIcon />
      </div>
      <div className={styles.title}>Супервайзер пока не выбран</div>
      <div className={styles.description}>
        Нажмите на одного из супервайзеров чтобы узнать подробности
      </div>
    </div>
  );
};
